import validate from "/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@18.17.19_db0@0.2.4_eslint@9.9.1_jiti@2.4.2__ior_3mjqpuv4wupqedynyqfg27frvu/node_modules/nuxt/dist/pages/runtime/validate.js";
import campaign_45global from "/app/app/middleware/campaign.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@18.17.19_db0@0.2.4_eslint@9.9.1_jiti@2.4.2__ior_3mjqpuv4wupqedynyqfg27frvu/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  campaign_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/app/middleware/auth.ts"),
  collection: () => import("/app/app/middleware/collection.ts")
}